import Vue from 'vue';

export default {
    namespaced: true,

    state: {loading: {}},

    getters: {
        isLoading: state => keys => {
            if (!Array.isArray(keys)) {
                keys = [keys];
            }
            return keys.some(key => !!state.loading[key]);
        },
    },

    mutations: {
        setLoading: (state, [key, loading]) => Vue.set(state.loading, key, loading),
    },

    actions: {
        async setLoading({commit}, [key, loading]) {
            if (loading) {
                commit('setLoading', [key, loading]);
            } else {
                // not hide loading indicator immediately, to allow other functions on same tick to finish
                await Vue.nextTick();
                commit('setLoading', [key, loading]);
            }
        },
    },
};